<template>
  <div>
    <div
      :class="loadingClasses"
      v-show="loading">Cargando turnos</div>
    <select
      :class="selectClasses"
      :style="selectInlineStyle"
      v-model="vModelSelectOptions" @change="sendDataSelect" v-show="!loading">
      <option value="null" disabled :style="optionInlineStyle">Selecciona un turno</option>
      <option :value="resgiter.id" v-for="(resgiter, i) in registers" :key="i" :style="optionInlineStyle">
        {{ resgiter.descripcion }}
      </option>
    </select>
  </div>
</template>
<script>
import { onMounted, ref } from "vue";
import axios from "../../api";
import { errorActions } from "@/alerts";
export default {
  name: "GetTurns",
  props: {
    selectOption: {
      type: Number,
      required: false,
    },
    variant: {
      type: String,
      default: "light",
      validator: (value) => ["light", "dark"].includes(value),
    },
  },
  emits: ['send-data'],//Si da problemas eliminarlo
  setup(props, { emit }) {
    const registers = ref([]);
    const loading = ref(true);
    const vModelSelectOptions = ref(1);
    const baseClasses = "py-2 px-3 text-sm border-2 focus:border-blue-500 block w-full rounded-lg mb-2 outline-none";

    const loadingClasses = ref(baseClasses);
    const selectClasses = ref(baseClasses);
    const selectInlineStyle = ref({});
    const optionInlineStyle = ref({});

    if (props.variant === "dark") {
      loadingClasses.value = `${baseClasses} turns-select turns-select-dark text-white bg-slate-800 border-sky-700 animate-pulse`;
      selectClasses.value = `${baseClasses} turns-select turns-select-dark text-white bg-slate-800 border-sky-700`;
      selectInlineStyle.value = {
        color: "#ffffff",
        backgroundColor: "#14344f",
        WebkitTextFillColor: "#ffffff",
      };
      optionInlineStyle.value = {
        color: "#ffffff",
        backgroundColor: "#14344f",
      };
    } else {
      loadingClasses.value = `${baseClasses} text-gray-600 bg-gray-100 animate-pulse uppercase`;
      selectClasses.value = `${baseClasses} text-gray-600 bg-gray-50 uppercase`;
    }

    //funcion para enviar datos desde este componente hacia el otro componente
    const sendDataSelect = () => {
      emit("send-data", vModelSelectOptions.value);
    };
    onMounted(async () => {
      try {
        const response = await axios.get("turnos/?page=1&per_page=200").catch((error) => {
          errorActions(error?.response?.data?.message || error.message || "No se pudo conectar con el backend para cargar los turnos.");
          return null;
        });

        if (!response?.data?.data) {
          loading.value = false;
          return;
        }

        registers.value = response.data.data;
        if (registers.value.length === 0) {
          return errorActions(
            "Lo sentimos no hemos encontrado un turno en nuestra base de datos"
          );
        }
        if (props.selectOption != "" && props.selectOption !== undefined) {
          vModelSelectOptions.value = props.selectOption || 1;
        } else {
          vModelSelectOptions.value = null;
        }
        loading.value = false;
      } catch (error) {
        errorActions(error);
      }
    });
    return {
      registers,
      loading,
      vModelSelectOptions,
      sendDataSelect,
      loadingClasses,
      selectClasses,
      selectInlineStyle,
      optionInlineStyle,
    };
  },
};
</script>

<style scoped>
.turns-select-dark,
.turns-select-dark option {
  color: #ffffff;
  background: #14344f;
}

.turns-select-dark option:disabled {
  color: rgba(255, 255, 255, 0.7);
}
</style>
